import React from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Steps = ({
  activeTab,
  setActiveTab,
  tabs = []
}) => /* @__PURE__ */ React.createElement(
  Tabs,
  {
    className: cx(styles.tabs),
    defaultIndex: activeTab,
    selectedIndex: activeTab,
    onSelect: setActiveTab
  },
  /* @__PURE__ */ React.createElement(
    TabList,
    {
      className: cx(styles.tabs__list, {
        [styles.active]: activeTab === 0
      })
    },
    tabs.map((item, i) => /* @__PURE__ */ React.createElement(Tab, { key: i, className: styles.tabs__tab }, item.tab))
  ),
  tabs.map((item, i) => /* @__PURE__ */ React.createElement(TabPanel, { key: i }, item.panel))
);
Steps.displayName = "Auth.Steps";

export { Steps };
//# sourceMappingURL=index.js.map
